import { loadPlugin } from 'yam-golang'
import { PluginDefinition } from 'yam-types'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'

import * as fs from 'fs/promises'
import * as path from 'path'

export default async function (): Promise<PluginDefinition<unknown>> {
  let wasmPath
  if (process.env.NODE_ENV === 'production') {
    // The NODE_ENV='production' environment variable is injected at build time.
    // Using require() to import a wasm file,
    // esbuild will send the file to the output directory and return the correct file path.
    wasmPath = require('./golang-example.wasm')
  } else {
    wasmPath = './golang-example.wasm'
  }
  const wasmFile = await fs.readFile(path.join(__dirname, wasmPath))

  // name and version are from package.json
  return {
    name,
    version,
    ...await loadPlugin(wasmFile),
    schema,
    settings,
  }
}
